module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-one"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("“C")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("’mon, honey, we’ve got to get going. You don’t want to be late for your first day of school.” Dan Morrow tossed his daughter’s backpack over his shoulder and reached for Natasha to help her down from the truck.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Bright orange buses pulled up along the sidewalk of Hartley Creek Elementary School, spilling out their loads of children. Some ran, some walked and some trudged up the sidewalk, their winter coats wide open, ignoring the chilly wind swirling snow around the school yard.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" British Columbia mountain weather, Dan thought with a shudder.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But Natasha sat on the truck seat, her hands folded over her stomach, her brown hair hiding her face and falling down the front of her bright red winter jacket.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “My tummy still hurts,” she said, peeking through her hair, adding a wince in case he didn’t believe her. “And I still miss my mommy.” Natasha sniffed, her brown eyes shimmering with tears.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Despite her performance of variations on the same theme for the past few minutes, his heart still twisted at her words. Though he and Lydia had been divorced for five years, Dan was still dealing with his ex-wife’s recent death. He couldn’t imagine what his little girl, who had lived with Lydia up until her death a month ago, was going through.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He pressed a kiss to Natasha’s head. “I know you’re sad, honey,” he said, tucking her hair behind her ear so he could see her face. “But school is starting and you don’t want to be late, do you?” He made his voice reasonable and soothing, hoping she would move.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The bell sounded and the last of the stragglers entered the school. Dan tossed a quick glance toward the grade one classroom directly ahead of him. Kids moved past the frosted windows, getting settled into their desks. A taller figure stopped, looking out the window. Even from here, he caught the red-gold shine of Hailey Deacon’s hair, that little tilt of her head that told him she was watching them. He’d seen her stop before to look out the window and watch them as soon as they pulled into the parking lot.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He tried not to let his heart flip the way it always did whenever he saw her, back when they were dating.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Since he and Natasha had come back to Hartley Creek, he’d managed to avoid Hailey, his old girlfriend. But she worked as a teacher’s aide in the grade one class his daughter was supposed to attend. A first meeting between them was inevitable.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan turned back to Natasha, his concern for his daughter taking priority.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I don’t want to go.” Her raised voice echoed over the now-empty school yard. “I want to stay with you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I know, but you have to start school. And I need to get back to work at Grandpa’s hardware store.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was about to tug on Natasha’s arm again when a glint of reflected light from the school’s door caught his attention. The door fell closed and there she was, her coat open, her hair flowing like a copper flag behind her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As she came closer he saw the concern on her delicate features, the frown above her gray eyes. His heart flipped again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Everything has changed,")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" he reminded himself, turning back to Natasha. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You were married. You’ve got a daughter. You lost your chance with her. Stay out of the past.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We’re going now,” he said to his daughter, trying to sound as if he was in charge.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But Natasha just looked ahead, her arms clasped tightly over her stomach.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Sorry to barge in,” Hailey was saying. “But I noticed from the window you were having some trouble.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan steeled himself, then turned to face his old girlfriend. She brushed a strand of hair back from her face as a hesitant smile played around the edges of her mouth. She looked as beautiful as she ever had. Maybe even more so. Old emotions seeped up from where he thought they were buried. He pushed them down. He had no right to get distracted.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Natasha is upset,” he said curtly. “She doesn’t want to go to school.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Of course she’s sad,” Hailey replied, coming around to stand beside him. Then Hailey gave him a sympathetic look that almost found its way through the barriers he had thrown up. “I’m sorry to hear about your wife.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Ex-wife.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She pulled back from him, his tone obviously accomplishing what he wanted—to keep her at arm’s length and protect himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I heard about that too.” She attempted another smile, then turned back to Natasha.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan looked down at the top of Hailey’s head. She still parted her hair in that jagged line, still let it hang free over her shoulders, still wore perfume that smelled like oranges.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He clenched his fists and turned his wavering attention back to his daughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hello, Natasha, my name is Miss Deacon.” Hailey held her hand out. “I’ll be helping you in school this morning.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She had pitched her voice to the same low, reassuring level she used when she taught children how to ski and snowboard on the ski hill.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I don’t want to go to school,” Natasha said, turning to Dan, her voice breaking. Her cries tore at Dan’s heart. He couldn’t leave her like this. But neither could he take Natasha back to the apartment above the hardware store. His father was recuperating from an extreme case of bronchial pneumonia. His mother worked at his hardware store and couldn’t watch Natasha. Dan didn’t know anyone who could babysit during the day.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He cleared his throat, embarrassed that Hailey had to witness his lack of control over his daughter. “I’m sorry, Natasha, but it’s time for school.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He tried to get his arms around her to lift her out of the truck, but she swung out at him. “I don’t want to go. Don’t make me go.” Her feet flailed in their heavy winter boots, hitting him in the arm. She wasn’t going willingly.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Now what should he do? Drag her into the building?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Dan, can I talk to you?” Hailey asked, catching his arm.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He shot her a puzzled glance and Hailey immediately released him, rubbing her hand against her pants, as if wiping away his touch.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As they walked away from the truck, Natasha’s cries grew louder and more demanding.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “If I can get her into the classroom, I’m sure she’ll be okay,” Dan insisted. “She just needs to know who’s in charge. Her mother always let her do whatever she wanted.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey sighed and he got the impression she didn’t agree with him. Big surprise. Hailey had always been the kind of girl who went her own way, did her own thing.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And you’re judging her after all the things you did?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The old guilt rose up again, a feeling that nagged at him as much as his self-reproach over his brother’s death seven years ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Natasha has had a lot to deal with in the last few weeks,” Hailey was saying. “Things have happened to her she had no control over and now she’s trying to find a way to take back some of that lost control. This is how she’ll do it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She sounded reasonable and, thankfully, practical. They were simply two adults discussing what to do about a little girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “But I need to get to work,” he said, glancing back at Natasha. “My mother needs me at the store now that Dad isn’t doing so well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I know that and you should go.” Hailey put her hand on his arm again. He was sure her gesture was automatic, but even through the thickness of his jacket her touch still managed to hit him square in the gut.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" This time he jerked away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “How will that work?” he asked, shoving his hands in the pockets of his jacket.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “The store isn’t that far from here.” Hailey folded her arms over her chest. “I suggest you leave the truck here and walk to the store. I’ll stay here with her until she’s ready to come inside.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan frowned, glancing from Natasha back to Hailey. “Don’t you need to get to the classroom?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Right now, my priority is your daughter. She won’t sit in that truck all day and even if she does that’s okay. Tomorrow we might have to do it again, but eventually she’ll get tired of sitting outside. If we let her make the decision, hopefully she’ll feel as if she has some say in the matter. Once that happens, she can slowly move into a routine which will help her in the healing process.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It seems like a lot of trouble,” he said, glancing over at Natasha, who had quieted down and was watching them with interest. “What if it takes all day?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m not that busy in the classroom today. Two days of the week I only work half-time. Today is one of those days.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “So what do you do the other half of those days?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As soon as he spoke he felt like hitting himself on the forehead. That was none of his business.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was also surprised to see a faint flush color Hailey’s cheeks. “I volunteer at the ski hill. Visit my Nana.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Her comment reminded him of her reason for her temporary return to Hartley Creek. “I heard about her heart attack. I’m sorry. I knew you and your sisters are very close to her. How is she feeling?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey tipped her head down, fingering a gold necklace hanging around her neck. “She’s doing very well. Thanks for asking.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The little hitch in her voice kindled concern for her and resurrected memories and emotions he thought he’d dealt with long ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He blinked, mentally pushing them away. Natasha and her care was his priority right now. Hailey didn’t even make the list. Besides, he had heard she was leaving town at the end of the school year.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He shifted his weight, trying to decide what to do, then glanced at his watch and his decision was made for him. Time was running out.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Okay. I’ll leave you with her,” he said with a resigned sigh. “But if you need me, call me at the store.” He reached in his shirt pocket for his pen and the pad of paper he always carried around.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She held up her hand in a stop gesture. “I know the number.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Of course she would remember. When they were dating, he worked at his father’s store after school and she would call him every day.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He shook off the memory as he glanced past her to his daughter, who still watched them with an intent gaze as if trying to figure out what they were talking about.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Just so you know, she’s incredibly stubborn and strong-willed.” His heart shifted at the sight of her, so small, sitting in the truck, her feet straight out. “But she really needs a routine in her life and the sooner the better.” Then he turned back to Hailey. “You call me if she gets upset or needs me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I will,” Hailey promised.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Still he hesitated. He’d had to walk away from Natasha so many times; he didn’t want to do it again. At least this time he would see her in a few hours instead of a few weeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I should say goodbye to her before I go,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Natasha’s expression grew hopeful when he approached the truck. He bent over and gave her a quick kiss and a hug. “I’m going to the store, honey. You can stay here in the truck, like you wanted.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Puzzlement creased her forehead as Dan straightened. She seemed unsure of this new twist in her plans.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He stepped away, fighting his own urge to give in to her. He zipped up his coat and walked toward Hailey. “You’ll let me know how things go?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’ll make sure she’s okay.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan gave her a tight nod, but before he left, their gazes met and held and it seemed as if the intervening years slipped away. Seven years of living away from Hartley Creek and a failed marriage drifted away like smoke with one look into those gray-blue eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Then the past slid into the present and with it came reality.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He had Natasha, his greatest blessing and the only positive consequence of his marriage.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Talk to you later,” was his gruff response as he steeled himself against old emotions.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" At one time he had loved Hailey. At one time they’d made plans. Then Austin’s death had crashed into their lives and with it had come a flood of guilt. Dan had promised his parents, who didn’t like for their sons to go snowboarding, that he would watch over Austin. He’d failed them when Austin died on a run he should never have started.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" And then Hailey had broken up with him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He straightened his shoulders. Hailey belonged to his past, not his present.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('br'), _c('br'), _vm._v(" “Adam, come here,” Hailey called out to the little boy who was about to run out of the school with no coat, no hat and no scarf. The temperature hovered around minus ten with the wind. The kid’s ears would freeze and his mother, Emma Minton, would be annoyed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Adam sighed, and turned around, trudging back to her, dragging his coat and his backpack. “Why do I have to put on my coat? It gets so hot in the bus.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey knelt down. “If something happens, we want you to be properly dressed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As she helped him with his coat, the doors at the end of the noisy hallway opened up again. A tall figure strode around the much smaller bodies, shifting to avoid the headlong rush of children released from the confines of the class.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Although she had seen Dan Morrow every afternoon for the past week, each time an echo of her old feelings lifted her heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was taller than he had been in high school; his shoulders had filled out and broadened. His blond hair had darkened, his face had gained a few more lines, but it was his gaze that snagged and held her attention.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His deep-set eyes used to mesmerize and melt her heart. Now they looked at her with a calm indifference that hurt her more than anger would have.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You broke up with him because he wanted to leave. Why do you care how he looks at you?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The question mocked her as she forced her attention back to Adam, who was squirming like a snake.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan reached for the door to the class, but Hailey held out a hand to stop him. “Natasha’s teacher, Miss Tolsma, wants to talk to you before you take Natasha home,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Why?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey hesitated, then angled him a quick glance. “Today was not…not Natasha’s best day,” she said, deliberately keeping her comment vague in front of Adam, Natasha’s classmate.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “At least she got out of the truck right away today,” Dan said, with a hopeful note in his voice. He shot a quick glance through the window in the classroom door at his daughter, who sat perched at the edge of a tiny chair, clutching her backpack.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey followed his glance and suppressed a sigh as she zipped up Adam’s coat.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It was Friday afternoon and school was done for the week. As he had the past four days, Dan had come to pick Natasha up. Megan Tolsma had asked Hailey to tell Dan she needed to talk to him. However, Megan was still in a staff meeting, leaving Hailey to fill the awkward silence between her and Dan with idle chitchat.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" At one time Hailey could have regaled Dan with stories about people they knew. Passed on a bit of gossip. Talked about the snow conditions on the mountain.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Now their history and the silence of the past seven years yawned like a chasm between them, and above that space floated memories of Austin’s death. The tragic event that pushed them apart. That sent Dan west to Vancouver and Hailey in the opposite direction.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan drummed his fingers against his thigh, obviously also aware of the awkwardness trembling between them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey dragged her attention back to Adam. “Are you still coming to the ranch next week?” Adam asked as Hailey tugged a toque on his head. “Mommy made your favorite chocolate cupcakes and put them in the freezer so me and Carter won’t eat them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m excited for cupcakes,” she said, hoping Dan didn’t hear the waver in her voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Please, Lord,")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" she prayed, ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("help me get over this. I don’t want to feel so confused around him. This has to get easier.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It’s that whole first love thing, she reminded herself. You never really forget the drama and emotions of that first love. She just had to try.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Yet, as she wrapped Adam’s scarf around his neck, she knew her reaction to Dan was beyond that of former high school sweethearts. Dan had been part of her dreams and the promise of a settled and secure future—something she had lacked with a mother who always wanted to be anywhere but Hartley Creek. And a father who had left her and her sisters long ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" While she tied up the ends of the scarf, Adam turned his attention back to Dan.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Are you Natasha’s daddy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes. Are you friends with her?” Dan asked back.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I want to be, but she doesn’t play with me. She’s not fun.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey tugged on Adam’s scarf to get his attention. “Remember? We only say good things about our friends,” she said, adding in a warning frown when Adam met her gaze.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She’s not my friend yet,” Adam protested. “She won’t play with me because all she does is cry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She needed to work on the potency of her frown, Hailey thought. Obviously it had no effect on Adam. As Hailey glanced back at Dan she caught a shadow of pain cross his expression.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" All week she and Megan had tried to be diplomatic with Dan in their discussions about Natasha. Dan kept insisting Natasha only needed a few more days to get used to the routine.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But Natasha needed more than a few more days to settle in. They hadn’t told him yet that Natasha had spent all of today hunched over her knapsack, her hair hanging over her face, silent tears streaming down her cheeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Megan was saving that information for the parent-teacher meeting this afternoon.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey pushed herself to her feet. “Out you go, buddy. Say hi to your mom and Carter for me,” she said, sending Adam out the door, watching to make sure he got to the bus. When she saw the principal of the school urging Adam on, she turned back to Dan.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “So, how does that kid know your cousin Carter?” Dan asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “His mother, Emma, and my cousin Carter are engaged.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Glad to hear that,” Dan said, slipping his hands in the back pockets of his jeans. “Carter’s had it pretty rough the past few years. What with losing his wife and then his little boy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey tried not to read too much into his knowledge of her family. Carter was her cousin, but he was also a part of the Hartley Creek community. Dan’s mother and father would have kept Dan abreast of what was going on.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Carter’s happy now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan nodded, then blew out a sigh. “What did that little guy mean when he said all Natasha does is cry?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Today wasn’t a good day for Natasha.” That was all she felt comfortable telling him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She’ll have her good and bad days, I guess,” Dan replied. The look he gave Hailey seemed to contain both challenge and hope.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She swallowed, unable to look away, wondering if he ever thought of their last time together and the fight they had. Had he done the same thing as she had done in the months that followed? Relive that conversation over and over? Say things differently?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" After Austin died, Dan had pulled back. She had understood that and had given him room to grieve. Then, when he finally asked to get together again it was to tell her that he wanted to move away from Hartley Creek. When she asked him why he said only that he needed space.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As she’d faced him down, Hailey had relived the pain she felt when she’d watched her father silently pack his suitcase, then walk past her and out of the house. She had been eight years old then and vividly remembered her helplessness.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Added to the past memory was the reality that four months before Austin’s accident, when Hailey had just graduated from high school, her mother, Denise, decided her youngest daughter was old enough to fend for herself. Her sisters, Naomi and Shannon, were out of the house already, so Denise packed up and moved away from Hartley Creek, leaving Hailey behind.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Then Dan wanted to leave her too?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It was all too much. This time she would be in charge, Hailey had thought. This time she wasn’t going to be left behind. So she’d broken up with him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Part of her had hoped, even yearned, that he would plead with her not to break up. That he would change his mind and want to stay in Hartley Creek with her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The first six months he was gone, she nurtured the faint hope he would return. When she heard about his marriage to Lydia she knew their relationship had ended.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Though the sting of that betrayal had stayed with her a long time, the memory of the love she had held for him lingered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" And now, looking into his eyes, that old memory grew stronger and she was reluctantly drawn into his gaze.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She couldn’t do this. Not here. Not now.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Relief flooded her when she saw Megan striding down the hall.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Here’s Miss Tolsma,” she said, reaching blindly for the handle of the classroom door. “I’ll sit with Natasha, until you’re finished.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Then she turned and retreated into the room, closing the door firmly on Dan and on the past.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She’d found out the hard way the only way to stay in control of your own life was to stay in control of your plans.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" No way was Dan disrupting them.")])])])]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cc58eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterOne.vue
// module id = 78
// module chunks = 0